import styled, { css } from 'styled-components'

type WrapperProps = {
  hasTestSelectInput?: boolean
  hasConclusionInput?: boolean
  hasQuestionInput?: boolean
}

export const Icon = styled.div`
  ${({ theme }) => css`
    content: '';
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid ${theme.colors.darkGray};
    border-radius: 6px;
    font-size: 2px;
    pointer-events: none;
  `}
`

export const Wrapper = styled.div<WrapperProps>`
  ${({
    theme,
    hasTestSelectInput,
    hasConclusionInput,
    hasQuestionInput
  }) => css`
    width: 100%;

    select {
      border: 1px solid ${theme.colors.lightGray};
      display: block;
      width: 100%;
      height: 48px;
      font-size: 1rem;
      padding: 0.6rem;
      border-radius: ${theme.border.smallRadius};
      background: ${theme.colors.white};
      transition: 0.2s;
      appearance: none;
      cursor: pointer;

      &:hover {
        outline: none;
        border-color: ${theme.colors.secondary};
        box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
      }

      ${hasTestSelectInput &&
      css`
        height: 50px;
        background: ${theme.colors.xxlightGray};

        &::placeholder {
          color: ${theme.colors.black};
        }
      `}
    }

    label {
      display: block;
      font-size: ${theme.font.sizes.xxxsmall};
      font-weight: ${theme.font.normal};
      line-height: 1;
      margin-top: 1rem;
      margin-left: 6px;
      padding-bottom: 0.3rem;
      color: ${theme.colors.white};
      position: relative;
    }

    ${hasConclusionInput &&
    css`
      select {
        height: 40px;
      }

      label {
        margin-top: 0;
        padding-bottom: 0;

        &::after {
          right: 12px;
          top: 18px;
        }
      }
    `}

    ${hasQuestionInput &&
    css`
      select {
        height: 54px;
      }

      label {
        margin-top: -9px;
        padding-bottom: 0;

        &::after {
          top: 25px;
        }
      }
    `}

    .error {
      color: ${theme.colors.red};
      font-size: ${theme.font.sizes.xxxsmall};
      font-weight: ${theme.font.bold};
      margin: 0px 0 4px 6px;
    }
  `}
`
